module.exports = __webpack_public_path__ + "img/wells-artesian.46e2b1bc.svg";